import { useEffect, useState } from "react";
import styles from "./CustomerPaymentsPage.module.scss";
import CommonPagination from "../../../common/components/pagination/CommonPagination";
import { useLazyGetTransactionsQuery } from "../../../service/customer-service";
import { toast } from "react-toastify";
import { formatDate } from "../../../utils";
import { useLazyVerifyWalletPaymentQuery } from "../../../service/virtual-wallet-service";
import { useLazyVerifyPaystackPaymentQuery } from "../../../service/paystack-service";
import { BounceLoader } from "react-spinners";

const CustomerPaymentsPage = () => {
	const pageSize = 15;
	const [currentPage, setCurrentPage] = useState(1);
	const [totalPages, setTotalPages] = useState(0);
	const [verifyingTransaction, setVerifyingTransaction] = useState<string | null>(null);

	const [getTransactions, { data, isLoading }] = useLazyGetTransactionsQuery();
	const [verifyWalletTransaction] = useLazyVerifyWalletPaymentQuery();
	const [verifyPaystack] = useLazyVerifyPaystackPaymentQuery();

	useEffect(() => {
		handleGetTransactions();
	}, []);

	useEffect(() => {
		handleGetTransactions();
	}, [currentPage]);

	const handleGetTransactions = () => {
		getTransactions({ page: currentPage, pageSize })
			.unwrap()
			.then(res => setTotalPages(res?.totalPages))
			.catch(err => toast.error(err?.data?.title as string));
	};


	const handleVerifyTransaction = (ref: string, type: string) => {
		setVerifyingTransaction(ref);

		const verifyAction = type === "Paystack Card" ? verifyPaystack : verifyWalletTransaction;

		verifyAction(ref)
			.unwrap()
			.then(res => {
				if (res?.status?.toLowerCase() !== "in-progress") {
					handleGetTransactions();
				}
			})
			.catch(err => toast.error(err?.data?.title as string))
			.finally(() => setVerifyingTransaction(null));
	};

	return (
		<div className={styles.ordersWrapper}>

			<div className={styles.pageHeader}>
				<h2>Payment History</h2>
			</div>
			<div className={styles.tableContainer}>
				<table className="standardTable">
					<thead>
						<tr>
							<th>AMOUNT PAID</th>
							<th>DATE OF PAYMENT</th>
							<th>PAYMENT CHANNEL</th>
							<th>PAYMENT REFRENCE</th>
							<th>PAYMENT STATUS</th>
							<th>VERIFY STATUS</th>
						</tr>
					</thead>
					<tbody>
						{data?.items?.map((item, index) => (
							<tr key={index}>
								<td>NGN {item?.amount.toLocaleString() || "-"}</td>
								<td>{formatDate(item?.dateOfPayment) || "-"}</td>
								<td>{item?.type}</td>
								<td>{item?.reference}</td>
								<td>{item?.status}</td>
								<td>
									{(item?.status?.toLowerCase() === "in-progress") && (item?.type === "Paystack Card" || item.type === "Virtual Account" || item?.type === "Paystack Card Authorization") && (
										<button
											className={`actionButton`}
											onClick={() => handleVerifyTransaction(item?.reference, item?.type)}
											disabled={verifyingTransaction === item?.reference}
										>
											{verifyingTransaction === item?.reference ? <BounceLoader color="var(--customer-primary)" size={15} /> : "VERIFY TRANSACTION"}
										</button>
									)}
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>

			<div className={styles.paginationContainer}>
				<CommonPagination
					currentPage={currentPage}
					isLoading={isLoading}
					numberOfPages={totalPages}
					onPageChange={(page: number) => {
						setCurrentPage(page);
					}}
				/>
			</div>
		</div>
	);
};

export default CustomerPaymentsPage;
